
export default class Form {
	constructor(el) {
		this.form = el

		if (this.form) {
			this.init()
		}
	}

	init() {
		const formData = new FormData(this.form);

		for(let [key, val] of formData.entries()){
			const element = this.form.querySelector('[name="'+ key +'"]:not([type="hidden"])')

			if (element) {
				const fieldContainer = element.closest('.gfield')

				if (fieldContainer) {
					element.addEventListener('input', () => {
						if (element.value !== '') {
							fieldContainer.classList.add('hasValue')
						} else {
							fieldContainer.classList.remove('hasValue')
						}
					})

					if (val) {
						fieldContainer.classList.add('hasValue')
					}
				}
			}
		}
	}
}
